function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.55944 7.78789L12.6718 0L14 1.38352L4.53204 10.4728L0 5.94071L1.35613 4.58458L4.55944 7.78789Z",
  fill: "#00BB77"
});
const SvgDone = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 11,
  viewBox: "0 0 14 11",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done.829ecda6.svg";
export { ForwardRef as ReactComponent };